<template>
	<div class="cell">
		<el-input ref="elInputRef" size="mini" v-model.trim="cellValue" @blur="blurFn"></el-input>
	</div>
</template>

<script>
	export default {
		props: {
			cellValue: {
				type: String | Number,
				default: ""
			},
			// 外部传递函数，当这个el-input失去焦点，通过此函数通知外部
			saveRowData: Function,
			cellDom: Node, //单元格Dom
			row: Object, //单元格所在数据
			property: String, //单元格的key
		},
		mounted() {
			//用户双击后，让其处于获取焦点的状态
			this.$refs.elInputRef.focus()
		},
		methods: {
			//失去焦点，再抛出去，通知外部
			blurFn() {
				this.saveRowData({
					cellValue: this.cellValue,
					cellDom: this.cellDom,
					row: this.row,
					property: this.property
				})
			}
		}
	}
</script>

<style>
	.cell {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		padding: 0 8px;
	}
</style>
